// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultLoader_container__wo0rm","centered":"DefaultLoader_centered__XFRdp"};